import { AttributeModel } from "src/models";

export const getAttributeDisplayName = ({ name, displayName }: AttributeModel) =>
  displayName || name;
